module.exports = __webpack_public_path__ + "img/14.5dc000e0.jpg";